"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var SplitFactory = require('@splitsoftware/splitio').SplitFactory;

var PromiseBb = require('bluebird');

var _require = require('lodash'),
    merge = _require.merge;

var FeatureToggle = /*#__PURE__*/function () {
  function FeatureToggle() {
    (0, _classCallCheck2["default"])(this, FeatureToggle);
    this.defaultConfig = {
      startup: {
        requestTimeoutBeforeReady: 1.5,
        // 1500 ms
        retriesOnFailureBeforeReady: 3,
        // 3 times
        readyTimeout: 1.5 // 1500 ms

      }
    };
  }

  (0, _createClass2["default"])(FeatureToggle, [{
    key: "init",
    value: function () {
      var _init = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var config,
            accountId,
            clientConfig,
            factory,
            _args = arguments;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                config = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
                accountId = _args.length > 1 && _args[1] !== undefined ? _args[1] : 'annonymus';
                clientConfig = accountId !== 'annonymus' ? merge({
                  core: {
                    key: accountId
                  }
                }, this.defaultConfig, config) : merge(this.defaultConfig, config); // {...config,...{core:{key:accountId}}}
                // Singleton pattern

                if (!FeatureToggle.instance) {
                  factory = SplitFactory(clientConfig);
                  this._client = factory.client();
                  FeatureToggle.instance = this;
                }

                FeatureToggle.instance._client.on('SDK_READY_TIMED_OUT', FeatureToggle._generateThrowSetupExeption('SDK_READY_TIMED_OUT'));

                _context.next = 7;
                return FeatureToggle._waitForEvent(FeatureToggle.instance._client, FeatureToggle.instance._client.Event.SDK_READY, clientConfig.startup.readyTimeout * 1000);

              case 7:
                return _context.abrupt("return", FeatureToggle.instance);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "isEnabled",
    value: function isEnabled(featureToggleName) {
      var accountId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'annonymus';
      var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var defaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      if (!('_client' in this)) FeatureToggle._generateThrowSetupExeption('Client did not init before first \'isEnabled\' usage', 'REQUIRE_FT_INIT')(); //if (!featureToggleName) FeatureToggle._generateThrowSetupExeption('[Validation error] isEnable: you passed a null or undefined \'featureToggleName\' / key, the key must be a non-empty string', 'REQUIRE_FT_KEY')();

      try {
        var result = this._client.isClientSide ? this._client.getTreatment(featureToggleName, attributes) : this._client.getTreatment(accountId, featureToggleName, attributes);
        return FeatureToggle._boolifyOffOn(result, defaultValue);
      } catch (err) {
        var stack = err.stack;
        console.error("[featureToggle] Faile to get treatment value, err:".concat(stack), {
          stack: stack
        });
      }

      return defaultValue;
    }
  }], [{
    key: "_boolifyOffOn",
    value: function _boolifyOffOn(treatment) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      switch (treatment) {
        case 'on':
          return true;

        case 'off':
          return false;

        case 'control':
          return defaultValue;

        default:
          return treatment;
      }
    }
  }, {
    key: "_waitForEvent",
    value: function _waitForEvent(eventEmitter, eventType) {
      var setTimeOut = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      return new PromiseBb(function (resolve) {
        eventEmitter.on(eventType, resolve);
      }).timeout(setTimeOut)["catch"](FeatureToggle._generateThrowSetupExeption("Timeout while waiting to event:".concat(eventType, ", setTimeout:").concat(setTimeOut)));
    }
  }, {
    key: "_generateThrowSetupExeption",
    value: function _generateThrowSetupExeption(reason) {
      var errCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : reason;
      return function () {
        var err = new Error("[featureToggle] Fail to start feaetureToggle instance, reason:".concat(reason));
        err.code = errCode;
        throw err;
      };
    }
  }]);
  return FeatureToggle;
}();

module.exports = new FeatureToggle();